/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-03 15:10:40
 * @Description: 
 */
import 'whatwg-fetch'
import 'scss_mixin/reset_pc.scss' //reset 样式
import 'tools/polyfill'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from "react-router-dom";
import App from './containers/App';
import './index.scss';

const rootElement = document.getElementById('root');

// 因为同一个项目内含多个官网，所以 basename 需要动态配置并配合模版部署的路径指向来实现
// 生产环境 basename 为/，开发环境 basename 为 /chefu
const basename = process.env.NODE_ENV === 'production' ? '/' : '/chefu';

ReactDOM.createRoot(rootElement!).render(
    <React.Suspense fallback={<div></div>}>
        <Router basename={basename}>
            <App />
        </Router>
    </React.Suspense>
);